import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { AsyncPipe } from '@angular/common';
import { MatCard, MatCardHeader, MatCardTitle, MatCardContent, MatCardActions } from '@angular/material/card';
import { MatButton } from '@angular/material/button';
import { TrafficService } from '_services/traffic.service';
import { TrafficChartComponent } from '../traffic-chart/traffic-chart.component';
import { HelpComponent } from '../../_shared/help/help.component';

@Component({
  selector: 'app-traffic',
  templateUrl: './traffic.component.html',
  styleUrls: ['./traffic.component.scss'],
  imports: [
    HelpComponent,
    MatCard,
    MatCardHeader,
    MatCardTitle,
    MatCardContent,
    MatCardActions,
    MatButton,
    TrafficChartComponent,
    AsyncPipe
  ]
})
export class TrafficComponent {
  constructor(
    private titleService: Title,
    public ts: TrafficService
  ) {
    this.titleService.setTitle('Traffic | NPC Admin');
  }
}
